import { t } from '@lingui/core/macro';
import { object, string } from 'yup';
export const makeSchema = () => object().shape({
    name: string().required(t({ message: 'Name is required', comment: 'Validation message for name field' })),
});
